import {Tool} from "./Tool";

export class PanTool extends Tool {

	constructor() {
		super();
		this.panning = false;
	}


	getCursor() {
		return this.panning ? "grabbing" : "grab";
	}

	mouseDown(e, canvas) {
		this.panning = true;
		this.startX = e.offsetX;
		this.startY = e.offsetY;
		this.startScrollX = canvas.scrollX;
		this.startScrollY = canvas.scrollY;
		return false;
	}

	mouseUp(e, canvas) {
		this.panning = false;
		return false;
	}

	mouseMove(e, canvas) {
		if (this.panning) {
			const diffX = e.offsetX - this.startX;
			const diffY = e.offsetY - this.startY;
			const scrollX = this.startScrollX + diffX;
			const scrollY = this.startScrollY + diffY;
			const change =  canvas.scrollX !== scrollX || canvas.scrollY !== scrollY;
			canvas.scrollX = scrollX;
			canvas.scrollY = scrollY;
			return change;
		}
		return false;
	}
}